import { useState, useEffect } from 'react';
import { Button, Tab } from 'semantic-ui-react';
import reportService from '../../services/api/reportService';
import Swal from 'sweetalert2';
import crecerFormsInstance from 'src/services/api/crecer';
import DateRangePicker from '../../components/common/DateRangePicker';
import DatePicker from '../../components/common/DatePicker';
import useDateRange from '../../components/common/useDateRange';
import useSingleDate from '../../components/common/useSingleDate';
import {
  CrecerReportContainer,
  CrecerFilters,
  crecerSteps,
  seminaryEvent,
  reportTypes,
} from './crecerShared';

const CrecerReport = () => {
  const [inputs, setInputs] = useState({
    type: reportTypes[0].value,
    step: crecerSteps[0].value,
    seminary: seminaryEvent[0].value,
  });
  const [loading, set_loading] = useState(false);
  const [counts, set_counts] = useState({});

  // Use custom hooks for date management
  const dateRange = useDateRange();
  const singleDateHook = useSingleDate();

  // Update inputs when date range changes
  useEffect(() => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      startDate: dateRange.startDateTimestamp,
      endDate: dateRange.endDateTimestamp,
    }));
  }, [dateRange.startDateTimestamp, dateRange.endDateTimestamp]);

  function getAttendantReport() {
    set_loading(true);

    const { startDate, endDate, step, seminary } = inputs;

    let body = {
      startDate,
      endDate,
    };

    let URL = '';
    let fileName = '';

    if (inputs.type === 'crecer') {
      URL = `/crecer/getAllCrecerAttendanceReports`;
      fileName = `InformeAsistenciaCrecer_${step}.xlsx`;
      body.step = step;
    }

    if (inputs.type === 'seminarios') {
      URL = `/seminaries/getAllSeminariesAttendanceReports`;
      fileName = `InformeAsistenciaSeminario_${seminary}.xlsx`;
      body.seminary = seminary;
    }

    reportService
      .getReport({ URL, fileName, body })
      .then(() => {
        set_loading(false);
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(false);
      });
  }

  function getSingleDateAttendance() {
    set_loading(true);

    let body = {
      date: singleDateHook.singleDateTimestamp,
    };

    crecerFormsInstance
      .getTotalsCrecerAttendanceByDay(body)
      .then((response) => {
        if (response.data && response.data.counts) {
          set_counts(response.data.counts);
        }
        set_loading(false);
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(false);
      });
  }

  const selectHandle = (e, { value, name }) => {
    setInputs({ ...inputs, [name]: value });
  };

  const panes = [
    {
      menuItem: 'Reporte por Rango',
      render: () => (
        <Tab.Pane>
          <div className="filters-section">
            <div className="date-range-section">
              <label htmlFor={'date'}>Rango de fechas</label>
              <p className="small">
                <small>El rango se basa en la ultima interacción del asistente</small>
              </p>
              <DateRangePicker
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                onStartDateChange={dateRange.handleStartDateChange}
                onEndDateChange={dateRange.handleEndDateChange}
                startDateLabel="Fecha Inicio"
                endDateLabel="Fecha Fin"
              />
            </div>

            <CrecerFilters inputs={inputs} onSelectChange={selectHandle} />
            <Button
              secondary
              disabled={loading}
              loading={loading}
              onClick={() => getAttendantReport()}
            >
              {loading ? 'Generando reporte...' : 'Descargar reporte'}
            </Button>
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Asistencia por Fecha',
      render: () => (
        <Tab.Pane>
          <div className="filters-section">
            <div className="single-date-section">
              <label htmlFor={'singleDate'}>Fecha específica</label>
              <p className="small">
                <small>Selecciona una fecha para ver la asistencia de ese día</small>
              </p>
              <DatePicker
                value={singleDateHook.singleDate}
                onChange={singleDateHook.handleSingleDateChange}
                id="singleDate"
                placeholder="Seleccionar fecha"
              />
            </div>
            <Button
              secondary
              disabled={loading || !singleDateHook.singleDate}
              loading={loading}
              onClick={() => getSingleDateAttendance()}
            >
              {loading ? 'Cargando...' : 'Ver'}
            </Button>

            {Object.keys(counts).length > 0 && (
              <div className="count-cards">
                {Object.keys(counts).every((key) => counts[key] === 0) && (
                  <div className="count-card">
                    <div className="count-label">No se encontraron resultados</div>
                  </div>
                )}
                {[...crecerSteps, ...seminaryEvent]
                  .filter((item) => counts[item.key] > 0)
                  .map((item) => (
                    <div key={item.key} className="count-card">
                      <div className="count-number">{counts[item.key]}</div>
                      <div className="count-label">{item.text}</div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </Tab.Pane>
      ),
    },
  ];

  return (
    <CrecerReportContainer>
      <div className="report-content">
        <h1>
          Reportes de <br /> crecer y seminarios
        </h1>
        <Tab panes={panes} />
      </div>
    </CrecerReportContainer>
  );
};

export default CrecerReport;
